import { useApi } from 'gf-ui';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Container } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router';
import { apiQuestionario } from '../api/apiQuestionario';
import BreadcrumbGF from '../components/BreadcrumbGF';
import Modelli from '../components/Modelli';

const QSubcategoria = ({ homeRoute, root, title, headerComponent }) => {

  const { ID_MA_CATEGORIA, ID_MA_MODELLO } = useParams()  
  const navigate = useNavigate()  
  const _apiQuestionario = useApi(apiQuestionario, null, root)
  const shouldInit = useRef(true)
  const [categoria, setCategoria] = useState(null)  
  const [subcategoria, setSubcategoria] = useState(null)  
  const [modelli, setModelli] = useState(null)

  const getModelli = useCallback(() => {
    _apiQuestionario.fnElencoModelli(res => {
      setCategoria(res.categoria)      
      setSubcategoria(res.subcategoria)      
      setModelli(res.modelli)
    }, { ID_PADRE: ID_MA_MODELLO })
  }, [ID_MA_MODELLO, _apiQuestionario])

  const onSelModello = (modello) => {
    navigate(`${homeRoute}/scheda/nuova/modello/${modello.KID}`)
  }  

  const breadcrumbItems = useMemo(()=>{
    return [      
      { path: `${homeRoute}`, label: title },
      { path: `${homeRoute}/categoria/${categoria && categoria.KID}`, label: categoria && categoria.DESCRIZIONE },
      { label: subcategoria && subcategoria.DESCRIZIONE }
    ]
  }, [categoria, homeRoute, subcategoria, title])

  useEffect(() => {
    if (shouldInit.current && _apiQuestionario) {
      shouldInit.current = false      
      _apiQuestionario.setFixedParams({         
        ID_CATEGORIA: ID_MA_CATEGORIA
      })
      getModelli()
    }
  }, [ID_MA_CATEGORIA, _apiQuestionario, getModelli])

  return <>
    { headerComponent }

    <BreadcrumbGF items={breadcrumbItems} />

    <h2 className='pt-4 text-center'>{categoria && categoria.DESCRIZIONE}</h2>

    <div className='w-100 p-0 m-0 bg-light'>
      <Container className='py-4'>      
        <Modelli modelli={modelli} onSelModello={onSelModello} />      
      </Container>
    </div>
  </>
}

export default QSubcategoria